import { Plugin } from "../partials";
import { getPlugins } from "../Api";
import { useParams } from 'react-router-dom';

export default function PluginCards(props) {
    const { lang } = useParams();
    const currentLang = lang || 'en';

    let list = getPlugins();

    return (<section className="max-w-screen-xl mx-auto p-4">
        <div className="grid md:grid-cols-3 xl:grid-cols-4 gap-4 xl:px-0">
            {
                list.map((item, index) => (
                    <Plugin key={index}
                        plugin={item}
                        url={`/${currentLang}/plugins/${item.slug}`} 
                        showMonthlyPrice={props.showMonthlyPrice}
                        />))
            }
        </div>
    </section>
    );
}